// =======================================================
// iOS SLIDER + YOUTUBE LIGHTBOX
// =======================================================
const IOS_SLIDER_CSS_ID = "ios-slider-css";

// =======================================================
// CSS
// =======================================================
function injectIosSliderCSS() {
  if (document.getElementById(IOS_SLIDER_CSS_ID)) return;
  const style = document.createElement("style");
  style.id = IOS_SLIDER_CSS_ID;
  style.textContent = `
.ios-slider{--radius:20px;--gap:14px;--peek:70%;--shadow:0 12px 30px rgba(0,0,0,.18);position:relative;width:100%;margin:0 auto;padding:10px;}
.ios-track{display:grid;grid-auto-flow:column;grid-auto-columns:calc(100% - var(--peek));gap:var(--gap);overflow-x:auto;scroll-snap-type:x mandatory;scroll-behavior:smooth;-webkit-overflow-scrolling:touch;padding:10px 12px 14px;scrollbar-width:none;}
.ios-track::-webkit-scrollbar{display:none;}
.ios-slide{position:relative;border-radius:var(--radius);overflow:hidden;scroll-snap-align:center;box-shadow:var(--shadow);background:#111;cursor:pointer;}
.ios-slide img{width:100%;aspect-ratio:16/9;object-fit:cover;display:block;}

/* Botones */
.ios-btn{position:absolute;top:50%;transform:translateY(-50%);width:42px;height:42px;border-radius:999px;border:0;cursor:pointer;background:rgba(255,255,255,.8);font-size:28px;display:grid;place-items:center;z-index:10;}
.ios-prev{left:10px;}.ios-next{right:10px;}
@media(max-width:640px){.ios-btn{display:none;}.ios-slider{--peek:6%;}}

/* LIGHTBOX ULTRA FUERTE */
.ios-lightbox{
  position:fixed !important;
  inset:0 !important;
  z-index:2147483647 !important;
  display:none;
  isolation:isolate !important;
  pointer-events:all;
}
.ios-lightbox[aria-hidden="false"]{
  display:flex !important;
  align-items:center;
  justify-content:center;
}
.ios-lightbox-bg{
  position:absolute;
  inset:0;
  background:rgba(0,0,0,.65);
  backdrop-filter:blur(18px);
  z-index:1;
}
.ios-lightbox-content{
  position:relative;
  z-index:2;
  width:100%;
  height:100%;
  display:grid;
  place-items:center;
  padding:20px;
}
.ios-video-wrapper{
  width:min(92vw,1200px);
  aspect-ratio:16/9;
  border-radius:24px;
  overflow:hidden;
  box-shadow:0 40px 120px rgba(0,0,0,.6);
  background:#000;
  z-index:3;
}
.ios-lightbox.is-short .ios-video-wrapper{
  width:min(92vw,420px);
  aspect-ratio:9/16;
  max-height:92vh;
}
.ios-video-wrapper iframe{width:100%;height:100%;border:0;}
.ios-lightbox-close{
  position:fixed !important;
  top:18px;right:18px;
  width:44px;height:44px;
  border-radius:999px;border:0;cursor:pointer;
  font-size:22px;background:rgba(255,255,255,.9);
  z-index:2147483647 !important;
}
.open-video{cursor:pointer;}
`;
  document.head.appendChild(style);
}

// =======================================================
// HTML - SOLO DEVOLVER EL SLIDER
// =======================================================
export function buildIosSliderHTML(items = []) {
  injectIosSliderCSS();

  const slidesHTML = items.map((item, i) => `
    <div class="ios-slide" data-video="${item.video}" aria-label="Slide ${i+1}">
      <img src="${item.image}" alt="Slide ${i+1}">
    </div>
  `).join("");

  return `
<div class="ios-slider" id="iosSlider1">
  <div class="ios-track">${slidesHTML}</div>
  <button class="ios-btn ios-prev">‹</button>
  <button class="ios-btn ios-next">›</button>
</div>`;
}

// =======================================================
// CREAR LIGHTBOX UNA SOLA VEZ EN EL BODY
// =======================================================
function createLightbox() {
  if (document.getElementById("iosLightbox")) return;

  const lightboxHTML = `
<div class="ios-lightbox" id="iosLightbox" aria-hidden="true">
  <div class="ios-lightbox-bg" data-close></div>
  <div class="ios-lightbox-content">
    <button class="ios-lightbox-close">✕</button>
    <div class="ios-video-wrapper">
      <iframe id="iosYoutubeFrame" allow="autoplay; encrypted-media" allowfullscreen></iframe>
    </div>
  </div>
</div>`;

  const div = document.createElement("div");
  div.innerHTML = lightboxHTML;
  document.body.appendChild(div.firstElementChild);
}

// =======================================================
// INIT
// =======================================================
export function initIosLightbox() {
  createLightbox(); // Crear solo una vez

  const lightbox = document.getElementById("iosLightbox");
  const iframe = document.getElementById("iosYoutubeFrame");
  const track = document.querySelector("#iosSlider1 .ios-track");

  if (!lightbox || !iframe) return;

  function openVideoLightbox(video){
    if (!video) return;

    const isShort = video.includes("/shorts/");
    iframe.src = convertYoutubeToEmbed(video);
    lightbox.classList.toggle("is-short", isShort);
    lightbox.setAttribute("aria-hidden","false");
    document.body.style.overflow = "hidden";
  }

  window.openVideoLightbox = openVideoLightbox;

  track?.addEventListener("click", e => {
    const slide = e.target.closest(".ios-slide");
    if (slide) openVideoLightbox(slide.dataset.video);
  });

  document.addEventListener("click", e => {
    const el = e.target.closest(".open-video");
    if (el) openVideoLightbox(el.dataset.video);
  });

  function close(){
    lightbox.setAttribute("aria-hidden","true");
    document.body.style.overflow = "";
    iframe.src = "";
  }

  lightbox.querySelector(".ios-lightbox-close")?.addEventListener("click", close);
  lightbox.querySelector("[data-close]")?.addEventListener("click", close);
  window.addEventListener("keydown", e => { if (e.key === "Escape") close(); });
}

// =======================================================
// CONVERT
// =======================================================
function convertYoutubeToEmbed(url) {
  if (!url) return "";
  let m = url.match(/youtube\.com\/shorts\/([^?&]+)/); if (m?.[1]) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0`;
  m = url.match(/[?&]v=([^&]+)/); if (m?.[1]) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0`;
  m = url.match(/youtu\.be\/([^?&]+)/); if (m?.[1]) return `https://www.youtube.com/embed/${m[1]}?autoplay=1&rel=0`;
  if (url.includes("/embed/")) return url + (url.includes("?") ? "&" : "?") + "autoplay=1&rel=0";
  return url;
}